import { useState, useCallback } from "react";

export const useBoolean = (initialState = false) => {
  const [flag, setFlag] = useState(initialState);

  const toggle = useCallback(() => {
    setFlag(curr => !curr);
  }, []);

  const on = useCallback(() => {
    setFlag(true);
  }, []);

  const off = useCallback(() => {
    setFlag(false);
  }, []);

  return [
    flag,
    {
      on,
      off,
      toggle
    }
  ] as const;
};
